import { render, staticRenderFns } from "./VerificationCard.vue?vue&type=template&id=5983be95&scoped=true&"
import script from "./VerificationCard.vue?vue&type=script&lang=js&"
export * from "./VerificationCard.vue?vue&type=script&lang=js&"
import style0 from "./VerificationCard.vue?vue&type=style&index=0&id=5983be95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5983be95",
  null
  
)

export default component.exports